import RouteGroup from '@/Setup/Routes/RouteGroup.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import auth from '@/Middlewares/auth.js'

export const endorsementGroupsRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('endorsement-groups', {
      list: () =>
        import(/* webpackChunkName: "underwriting" */ './Pages/List.vue'),
    })
      .only(['list'])
      .permissions({
        list: 'endorsement-groups.view',
      })
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
